import { restApi } from "../restApi";
import { DEFAULT_API_PAYLOAD } from "~/lib/constants";
const version = "1";

export const dailyOpsApi = restApi.injectEndpoints({
  endpoints: (builder) => ({
    // Job Safety Analysis (JSA)
    getJSAs: builder.query<
      any,
      {
        "App-Name"?: string;
        pageNumber?: number;
        pageSize?: number;
        searchTerm?: string;
      }
    >({
      query: (queryArg = {}) => ({
        url: `/api/v${version}/jsa`,
        params: {
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          searchTerm: queryArg.searchTerm,
        },
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      providesTags: ["JSA" as any],
    }),
    getJSA: builder.query<any, { id: string; "App-Name"?: string }>({
      query: (queryArg) => ({
        url: `/api/v${version}/jsa/${queryArg.id}`,
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      providesTags: ["JSA" as any],
    }),
    createJSA: builder.mutation<any, { body: any; "App-Name"?: string }>({
      query: (queryArg) => ({
        url: `/api/v${version}/jsa`,
        method: "POST",
        body: queryArg.body,
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      invalidatesTags: ["JSA" as any],
    }),
    updateJSA: builder.mutation<
      any,
      { id: string; body: any; "App-Name"?: string }
    >({
      query: (queryArg) => ({
        url: `/api/v${version}/jsa/${queryArg.id}`,
        method: "PUT",
        body: queryArg.body,
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      invalidatesTags: ["JSA" as any],
    }),
    deleteJSA: builder.mutation<any, { id: string; "App-Name"?: string }>({
      query: (queryArg) => ({
        url: `/api/v${version}/jsa/${queryArg.id}`,
        method: "DELETE",
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      invalidatesTags: ["JSA" as any],
    }),
    // Permit to Work (PTW)
    getPTWs: builder.query<
      any,
      {
        "App-Name"?: string;
        page?: number;
        pageSize?: number;
        searchTerm?: string;
      }
    >({
      query: (queryArg = {}) => ({
        url: `/api/v${version}/daily-ops/ptws`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          searchTerm: queryArg.searchTerm,
        },
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      providesTags: ["PTW" as any],
    }),
    getPTW: builder.query<any, { id: string; "App-Name"?: string }>({
      query: (queryArg) => ({
        url: `/api/v${version}/daily-ops/ptws/${queryArg.id}`,
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      providesTags: ["PTW" as any],
    }),
    createPTW: builder.mutation<any, { body: any; "App-Name"?: string }>({
      query: (queryArg) => ({
        url: `/api/v${version}/daily-ops/ptws`,
        method: "POST",
        body: queryArg.body,
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      invalidatesTags: ["PTW" as any],
    }),
    updatePTW: builder.mutation<
      any,
      { id: string; body: any; "App-Name"?: string }
    >({
      query: (queryArg) => ({
        url: `/api/v${version}/daily-ops/ptws/${queryArg.id}`,
        method: "PUT",
        body: queryArg.body,
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      invalidatesTags: ["PTW" as any],
    }),
    deletePTW: builder.mutation<any, { id: string; "App-Name"?: string }>({
      query: (queryArg) => ({
        url: `/api/v${version}/daily-ops/ptws/${queryArg.id}`,
        method: "DELETE",
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      invalidatesTags: ["PTW" as any],
    }),
    // COSHH Assessment
    getCOSHHAssessments: builder.query<
      any,
      {
        "App-Name"?: string;
        page?: number;
        pageSize?: number;
        searchTerm?: string;
      }
    >({
      query: (queryArg = {}) => ({
        url: `/api/v${version}/coshh`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          searchTerm: queryArg.searchTerm,
        },
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      providesTags: ["COSHH" as any],
    }),
    getCOSHHAssessment: builder.query<any, { id: string; "App-Name"?: string }>(
      {
        query: (queryArg) => ({
          url: `/api/v${version}/coshh/${queryArg.id}`,
          headers: {
            "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
          },
        }),
        providesTags: ["COSHH" as any],
      },
    ),
    createCOSHHAssessment: builder.mutation<
      any,
      { body: any; "App-Name"?: string }
    >({
      query: (queryArg) => ({
        url: `/api/v${version}/coshh`,
        method: "POST",
        body: queryArg.body,
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      invalidatesTags: ["COSHH" as any],
    }),
    updateCOSHHAssessment: builder.mutation<
      any,
      { id: string; body: any; "App-Name"?: string }
    >({
      query: (queryArg) => ({
        url: `/api/v${version}/coshh/${queryArg.id}`,
        method: "PUT",
        body: queryArg.body,
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      invalidatesTags: ["COSHH" as any],
    }),
    deleteCOSHHAssessment: builder.mutation<
      any,
      { id: string; "App-Name"?: string }
    >({
      query: (queryArg) => ({
        url: `/api/v${version}/coshh/${queryArg.id}`,
        method: "DELETE",
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      invalidatesTags: ["COSHH" as any],
    }),
  }),
});

export const {
  useGetJSAsQuery,
  useGetJSAQuery,
  useCreateJSAMutation,
  useUpdateJSAMutation,
  useDeleteJSAMutation,
  useGetPTWsQuery,
  useGetPTWQuery,
  useCreatePTWMutation,
  useUpdatePTWMutation,
  useDeletePTWMutation,
  useGetCOSHHAssessmentsQuery,
  useGetCOSHHAssessmentQuery,
  useCreateCOSHHAssessmentMutation,
  useUpdateCOSHHAssessmentMutation,
  useDeleteCOSHHAssessmentMutation,
} = dailyOpsApi;
